export type StageOpenGesture = 'single' | 'double';

/**
 * How a folder (stage) card/row — and a selectable measurement card/row —
 * behaves in the monitoring stage browser:
 *   'single' -> single-click opens; no selection concept (LAUNCH DEFAULT)
 *   'double' -> single-click selects (ring + selection summary),
 *               double-click / Enter opens (Drive-like); enables the
 *               cross-stage selection tray + bulk actions work
 *
 * Launching on 'single'. The selection/double-click machinery is fully
 * built behind this flag; flip to 'double' for a cohort once bulk actions
 * exist. Intended to be replaced by a PostHog feature flag for a staged
 * rollout — read it there and fall back to STAGE_OPEN_GESTURE.
 * See docs/superpowers/specs/2026-09-04-monitoring-ux-revamp-design.md §9.2.
 */
export const STAGE_OPEN_GESTURE: StageOpenGesture = 'single';
